'use strict';

customerZone.factory('CacheBusterProvider', [function () {
    return function(){
        return Date.now().toString(16);
    };
}]);
